export default "__VITE_ASSET__DYlVsQ_6__"